import { getModifierValueOptions } from '../helpers';
import { useFetchUsers } from '../hooks/useFetchUsers';
import { SimpleFilterComponentProps } from './FilterComponentProps';
import { FilterMultiSelect } from './FilterMultiSelect';

export const FilterUserSelect = ({
  filterItem,
  ...props
}: SimpleFilterComponentProps) => {
  const { data: allModifiers, isLoading } = useFetchUsers();

  const valueOptions = getModifierValueOptions(allModifiers ?? []);
  const loadedFilterItem: typeof filterItem = {
    ...filterItem,
    column: { ...filterItem.column, valueOptions, areValuesLoading: isLoading },
  };
  return <FilterMultiSelect filterItem={loadedFilterItem} {...props} />;
};
